var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventcallicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_322_115)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.248 12.1296C13.8159 13.4428 12.1228 14.098 10.9132 13.9888C9.26119 13.8395 7.46359 12.9631 6.09905 11.998C4.09332 10.5793 2.21452 8.38507 1.11972 6.05641C0.345987 4.41094 0.172387 2.38747 1.32319 0.887606C1.74879 0.333206 2.20985 0.0373397 2.90052 0.00280638C3.85999 -0.0438603 3.99439 0.50494 4.32385 1.35987C4.56932 1.99921 4.89692 2.65161 5.07985 3.31427C5.42239 4.55094 4.22492 4.60227 4.07372 5.61307C3.98039 6.25054 4.75225 7.10547 5.10132 7.56001C5.77415 8.44525 6.59821 9.20454 7.53545 9.80281C8.06745 10.1379 8.92425 10.7417 9.53279 10.4085C10.4699 9.89521 10.3821 8.31507 11.6916 8.84987C12.3701 9.12614 13.0272 9.52467 13.6749 9.87374C14.6764 10.4123 14.6297 10.9704 14.248 12.1296C14.5336 11.2635 13.9624 12.9957 14.248 12.1296Z",
    fill: "#D10A11"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_322_115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventcallicon);
export default __webpack_public_path__ + "static/media/eventcallicon.beda2fdcebf5f30dfc10cbca313e39fa.svg";
export { ForwardRef as ReactComponent };